module.exports = __webpack_public_path__ + "static/img/no_data.89b0ad9f.png";